import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";

import { InvoiceFee, RowInvoice } from "../../types/invoice";
import { InvoiceRows } from "../index";
import formatSpecialFee from "../../helpers/formatSpecialFee";

import styles from "./InvoiceFeeDetails.module.scss";
import { priceToFormat } from "../../helpers/invoice";

interface Props {
  invoiceFees: InvoiceFee[];
}

const InvoiceFeeDetails = ({ invoiceFees }: Props) => {
  const { t } = useTranslation();

  const feeRows: RowInvoice[] = useMemo((): RowInvoice[] => {
    return [
      {
        name: t("invoices.invoiceFee"),
        key: "specialFeesTitle",
        value: "",
        isTitle: true,
      },
      ...invoiceFees.map(
        (fee: InvoiceFee): RowInvoice => ({
          name: fee.feeName,
          key: fee.specialFeeId.toString(),
          value: formatSpecialFee(fee),
          rate: priceToFormat(fee.calculatedFee),
          isRedValue: fee.calculatedFee < 0,
        })
      ),
    ];
  }, [t, invoiceFees]);

  return (
    <table className={styles.feeDetailsBody}>
      <tbody>
        {feeRows.map((row) => {
          return <InvoiceRows key={row.key} {...row} />;
        })}
      </tbody>
    </table>
  );
};

export default InvoiceFeeDetails;
